/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AIGenerateBrandedIcon = /*#__PURE__*/ createSvgIcon(
  'AIGenerateBrandedIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M14.925 3.174a.28.28 0 00-.517 0l-.403.987a.93.93 0 01-.51.51l-.988.404a.28.28 0 000 .517l.988.403a.93.93 0 01.51.51l.403.988a.28.28 0 00.517 0l.403-.988a.931.931 0 01.51-.51l.988-.403a.28.28 0 000-.517l-.988-.404a.931.931 0 01-.51-.51l-.403-.987z"
            fill={`url(#${id}_0)`}
          />
          <path
            d="M9.654 4.845a.466.466 0 00-.863 0L7.936 6.94a4.66 4.66 0 01-2.552 2.553l-2.094.854a.466.466 0 000 .863l2.094.855a4.66 4.66 0 012.552 2.552l.855 2.094a.466.466 0 00.863 0l.854-2.094a4.66 4.66 0 012.553-2.552l2.094-.855a.466.466 0 000-.863l-2.094-.854a4.66 4.66 0 01-2.553-2.553l-.854-2.094z"
            fill={`url(#${id}_1)`}
          />
          <defs>
            <linearGradient
              id={`${id}_0`}
              x1={1.941}
              y1={17}
              x2={20.891}
              y2={16.531}
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#0048B0" />
              <stop offset={1} stopColor="#1E72EB" />
            </linearGradient>
            <linearGradient
              id={`${id}_1`}
              x1={1.941}
              y1={17}
              x2={20.891}
              y2={16.531}
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#0048B0" />
              <stop offset={1} stopColor="#1E72EB" />
            </linearGradient>
          </defs>
        </>
      ),
    },
  },
  false
);

export default AIGenerateBrandedIcon;
